import qfSignals from "quickfire/qf-signals";
import { VEventEnum } from "quickfire/v/enums";
import gameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

export function QuickfireEndRound() {
    const isFreespins = gameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord;

    if (!isFreespins) {
        qfSignals.dispatch(VEventEnum.gameRoundCompleted);
    }
}
